import Vue from "vue";
import VueRouter from "vue-router";
import Topic from "@/pages/topic/index";
import Order from "@/pages/order/index";
import Shop from "@/pages/shop/index";
import Draw from "@/pages/draw/index";
import Discuss from "@/pages/discuss/index";
import Ticket from "@/pages/ticket/index";
import User from "@/pages/user/index";
import UserTask from "@/pages/usertask/index";
import Games from "@/pages/games";
import Privilege from "@/pages/privilege";
import Yun from "@/pages/yun";
Vue.use(VueRouter);

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: {
      name: "create.topic",
    },
  },
  ...Topic,
  ...Order,
  ...Shop,
  ...Draw,
  ...Discuss,
  ...Ticket,
  ...User,
  ...UserTask,
  ...Games,
  ...Privilege,
  ...Yun,
  {
    path: "/*",
    component: () => import("@/pages/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes,
});
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
